export function createRetryIdentity() {
  let signature, id;
  return {
    forPayload(payload) {
      const next = JSON.stringify(payload);
      if (next !== signature || !id) {
        signature = next;
        id = globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {const n = Math.floor(Math.random()*16); return (c === 'x' ? n : (n&3)|8).toString(16);});
      }
      return id;
    },
    clear() { signature = undefined; id = undefined; },
  };
}
